import { Navigate, generatePath } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { BLOG_SPORT_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { sportToBlogSportMap } from '@sorare/core/src/lib/routing';

import type { PageParams } from './__generated__/routeParams.ts';

const BlogRedirect = () => {
  const { slug } = useTypedParams<PageParams>();
  const { sport } = useSportContext();

  return (
    <Navigate
      to={generatePath(BLOG_SPORT_SLUG, {
        sport: sportToBlogSportMap[sport],
        slug,
      })}
    />
  );
};

export default BlogRedirect;
